import React, { useEffect, useState } from 'react';

import Spin from '@fmbt/ui/Spin';
import FarmbotLogoHorizontal from 'components/atoms/FarmbotLogoHorizontal';

import './styles.less';

interface Props {
  /**
   * Specify if the farmbot logo should be used instead of a loading spinner.
   */
  useLogo?: boolean;
  size?: number;
  color?: React.CSSProperties['color'];
  /** Delay in ms */
  delay?: number;
  zIndex?: number;
}

function LoadingSpinner({
  useLogo,
  size = 30,
  color,
  delay = 300,
  zIndex
}: Props): JSX.Element {
  const [showSpinner, setShowSpinner] = useState(
    () => !useLogo && delay <= 0
  );

  useEffect(() => {
    if (useLogo) {
      return undefined;
    }
    if (delay <= 0) {
      setShowSpinner(true);
      return undefined;
    }
    let isMounted = true;
    const timer = window.setTimeout(() => {
      if (isMounted) {
        setShowSpinner(true);
      }
    }, delay);
    return () => {
      isMounted = false;
      window.clearTimeout(timer);
    };
  }, [delay, useLogo]);

  return (
    <div
      className="LoadingSpinner"
      style={zIndex !== undefined ? { zIndex } : undefined}
    >
      {useLogo && <FarmbotLogoHorizontal />}
      {!useLogo && showSpinner && (
        <Spin indicatorColor={color} indicatorSize={size} />
      )}
    </div>
  );
}

export default LoadingSpinner;
